export default (
    Object.freeze({ 
        projectionValues: [{
            'label': 'Projected market performance',
            'value': '1'
        }, {
            'label': 'If markets perform better',
            'value': '2'
        }, {
            'label': 'If markets perform worse',
            'value': '3'
        }],

        pensionTarget: [{
            label: 'Base on my salary',
            value: '1'
        }, {
            label: 'Choose my own target',
            value: '2'
        }, {
            label: 'I don\'t want to set a target',
            value: '3'
        }],
        
        timeframe: [{
            label: 'Per Week',
            value: '1'
        }, { 
            label: 'Per Month',
            value: '2',
        }, {
            label: 'Per Year',
            value: '3'
        }]
    })
);